import type { Action } from './actions'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'
import type { MetaShortDTO } from 'shared/types/api'

export type State = {
    dataLoaded: ?boolean,
    metaData: ?MetaShortDTO,
    code: ?string,
    kingdomAuthCode: string,
    blazonProfileImageUrl?: string,
    cardError?: any,
    cardNetworkError?: any
}

const initialState: State = {
    metaData: null,
    dataLoaded: false,
    code: '',
    kingdomAuthCode: '',
    blazonProfileImageUrl: ''
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_CARD_RESPONSE':
            return {
                ...state,
                ...action.data,
                dataLoaded: true,
                cardError: undefined,
                cardNetworkError: undefined
            }
        case 'PAGE_DATA_DASHBOARD_RESPONSE':
            return {
                ...state,
                code: action.data.loyaltyCardCode
            }
        case 'CARD_ERROR':
            return {
                ...state,
                cardError: action.cardError
            }
        case 'SIGNIN_SEND_FORM_SUCCESS':
        case 'SOCIAL_PENDING':
        case 'SIGNUP_SEND_FORM_SUCCESS':
            return {
                ...state,
                cardError: undefined
            }
        case 'LOGOUT':
            return initialState
        case 'PAGE_API_ERROR':
            return managePageAPIError(
                state,
                action,
                endpoints.kingdom.card.page,
                'cardError'
            )
        case 'PAGE_API_AUTH_ERROR':
            return {
                ...state,
                cardError: action.error
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                cardNetworkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                cardNetworkError: action.networkError,
                cardError: undefined
            }
        default:
            return state
    }
}
